import { AnyFieldApi } from '@tanstack/react-form';
import { $ZodIssue as ZodIssue } from '@zod/core';

interface FieldInfoProps {
  field: AnyFieldApi;
}

export function FieldInfo({ field }: FieldInfoProps) {
  const errors: ZodIssue[] = field.state.meta.errors ?? [];

  return (
    <>
      {field.state.meta.isTouched && !field.state.meta.isValid
        ? errors.map((error, index) => {
            return (
              <div key={index} className="text-sm text-red-500 mt-1">
                {error.message}
              </div>
            );
          })
        : null}

      {field.state.meta.isValidating ? 'Validating...' : null}
    </>
  );
}
